import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

interface ClientLike {
  userId?: string;
  clientId?: string;
  status?: string;
  taxInfo?: {
    status?: string;
  };
}

interface NavigateOptions<T = any> {
  onArchived?: (client: T) => void;
  onBeforeNavigate?: () => void;
  taxYear?: number | null;
}

export const useClientNavigation = () => {
  const navigate = useNavigate();

  const navigateToClient = useCallback(
    <T extends ClientLike>(client: T, options?: NavigateOptions<T>) => {
      // Support both userId (old) and clientId (new) field names
      const clientIdentifier = client.userId || client.clientId;

      if (!client || !clientIdentifier) return;

      const status = client.taxInfo?.status ?? client.status;

      if (status === "Archived") {
        options?.onArchived?.(client);
        return;
      }

      options?.onBeforeNavigate?.();

      // If taxYear is provided and not null, include it in the URL
      // If taxYear is null (All Years selected), omit it to let profile decide
      if (options?.taxYear) {
        navigate(`/clients/${clientIdentifier}/${options.taxYear}`);
      } else {
        navigate(`/clients/${clientIdentifier}`);
      }
    },
    [navigate]
  );

  return { navigateToClient };
};
